<template>
  <div>
    <text-input
      id="email"
      v-model="form.email"
      type="email"
      label="Email"
      required
      maxlength="64"
    />

    <password-input
      id="password"
      v-model="form.password"
      label="Password"
      required
    />
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },

  data() {
    return {
      form: this.value,
    };
  },

  watch: {
    form: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
};
</script>
